import { render, staticRenderFns } from "./ProductsActions.vue?vue&type=template&id=689731cc&scoped=true"
import script from "./ProductsActions.vue?vue&type=script&lang=ts"
export * from "./ProductsActions.vue?vue&type=script&lang=ts"
import style0 from "./ProductsActions.vue?vue&type=style&index=0&id=689731cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689731cc",
  null
  
)

export default component.exports